export enum typeSort {
    price,
    time
}
